




import { defineComponent } from "@vue/composition-api";
import BaseIcon from "@/components/BaseIcon";
import BaseImage from "@/components/BaseImage";

export default defineComponent({
  name: "MediaImageView",
  components: { BaseIcon, BaseImage },
  props: {
    src: { type: String },
    isPublic: { type: Boolean, default: true },
    icon: { type: String, default: "sci-image" },
  },
});
